<template>
    <div class="publicizeList flex-sub flex flex-direction">
        <div class="list-box flex-sub  flex flex-direction">
            <div class="search-box">
                <i class="iconfont icon-sousuo2"></i>
                <input v-model="search.keyword" placeholder="输入名称搜索" type="text">
                <div class="btn" @click="searchFun">
                    搜索
                </div>
            </div>
<!--            <van-pull-refresh class="flex-sub" v-model="refreshing" @refresh="onRefresh">-->
<!--                <van-list-->
<!--                    v-model="loading"-->
<!--                    :finished="finished"-->
<!--                    class="org-list"-->
<!--                    finished-text="没有更多了"-->
<!--                    @load="onLoad">-->
          <div class="org-list">
            <div v-for="item in lists" :key="item.id" class="org ovHide" @click="showMask(item)">
              {{ item.org_name }}
            </div>
          </div>

<!--                </van-list>-->
<!--            </van-pull-refresh>-->
        </div>
        <orgDetailDialog :dialogVisible="dialogVisible" :item="item" @handleClose="handleClose"/>
    </div>
</template>
<script>
import {masses_org_lst} from "@/api";
import orgDetailDialog from "@/views/h5/common/orgDetailDialog";

export default {
    name: "policyList",
    data() {
        return {
            dialogVisible: false,
            item: {},
            type: 1,
            bannerTex: '',
            bannerStr: '',
            search: {
                keyword: '',
                page: 1,
                limit: 9999999,
                total: 0,
            },
            lists: [],
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    components: {orgDetailDialog},
    created() {
        this.type = this.$route.query.type
        this.onLoad()
    },
    methods: {
        async onLoad() {
            // if (this.refreshing) {
            //     this.lists = [];
            //     this.search.page = 1
            //     this.refreshing = false;
            // }
            let _data = await masses_org_lst(
                this.type,
                this.search.keyword,
                this.search.page,
                this.search.limit
            );
            // this.loading = false
            if (_data.status === 200) {
                this.lists = [...this.lists, ..._data.data.data]
                // if (this.lists.length >= _data.data.total) {
                //     this.finished = true;
                // }
                // this.search.page += 1
                // this.search.total = _data.data.total
            }else{
                this.lists=[]
                this.search.total = 0
                this.finished = true;
            }
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        showMask(item) {
            this.item = item;
            this.dialogVisible = true;
        },
        searchFun() {
            this.refreshing = true
            this.search.page = 1
            this.list()
        },
        bannerFun() {
            switch (Number(this.type)) {
                case 1:
                    document.title = '海淀区科技类教培机构持证名单'
                    break;
                case 2:
                    document.title = '开通资金监管账户机构名单'
                    break;
                default:
                    document.title = '详情'
                    break;
            }
        },
        handleClose() {
            this.dialogVisible = false
            this.item = {}
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.publicizeList {
    background: #ebf4ff;
    padding: 2.9vw 3.5vw;
    .search-box {
        width: 100%;
        height: 10.1vw;
        background-color: #ffffff;
        box-shadow: 0.7vw 0.5vw 2.4vw 0vw
        rgba(0, 46, 108, 0.17);
        border-radius: 1.3vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 3vw;
        position: sticky;
        top: 2.9vw;
        z-index: 2;
        .btn {
            width: 14.7vw;
            height: 7.5vw;
            background-color: #2d94ff;
            border-radius: 1.3vw;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.7vw;
            color: #ffffff;
            cursor: pointer;
        }

        .iconfont {
            color: #999999;
            font-size: 3.7vw;
            margin-right: 3vw;
        }
        input {
            flex: 1;
            height: 10.1vw;
            font-size: 3.7vw;
            color: #333333;
        }
    }


    .org-list {
        width: 100%;
        padding: 4vw;
        display: flex;
        flex-direction: column;
        background-image: linear-gradient(0deg,
            #ffffff 0%,
            #e1eeff 100%);
        border-radius: 1.9vw;
        border: solid 0.1vw #ffffff;
        margin-top: 3vw;

        .org {
            width: 100%;
            height: 7.1vw;
            background-color: #ffffff;
            box-shadow: 0vw 0vw 2.1vw 0vw rgba(7, 65, 149, 0.05);
            border-radius: 1.3vw;
            padding: 0 3.7vw;
            line-height: 7.1vw;
            font-size: 3.7vw;
            color: #2c2c2c;
            cursor: pointer;

            & + .org {
                margin-top: 1.3vw;
            }
        }
    }

}
</style>


